'use client'
import React from 'react'

import dynamic from 'next/dynamic'
// import { useQuery } from '@apollo/client'
import PropTypes from 'prop-types'
// const Skeleton = dynamic(() => import('@shared/components/skeleton'), { ssr: false })
const TrendingNewsContent = dynamic(() => import('@shared/components/trendingNews/trendingNewsContent'))
// const TrendingNewsContent = dynamic(() => import('@shared/components/trendingNews/trendingNewsContent'), {
//   loading: () => loader
// })

// const loader =
//   <>
//     {Array.from(Array(3)).map((e, i) => {
//       return (
//         <div className='my-3 d-flex' key={i}>
//           <div>
//             <Skeleton height={'60px'} width={'96px '} />
//           </div>
//           <div className='w-100 ps-2'>
//             <Skeleton height={'40px'} className={'mb-2'} />
//             <div height={'14px'} className="d-flex">
//               <Skeleton width={'20%'} height={'14px'} className={'me-2'} />
//               <Skeleton width={'20%'} height={'14px'} className={'me-3'} />
//             </div>
//           </div>
//         </div>
//       )
//     })}

//   </>

function OlympicsTrendingNews({ data }) {
  // const { data, loading } = useQuery(TRENDING_NEWS, {
  //   variables: { input: { nSkip: 0, nLimit: 8 } }
  // })

  return (
    <>
      {
        data?.length !== 0 &&
        <div className="trendingNews trending-news widget">
          <div className="widget-title d-flex justify-content-between align-items-center">
            <h3 className="small-head d-flex align-items-center mb-0 fw-bold">
            {'Trending News'}
            </h3>
          </div>
          <div className="trendingList">
             <TrendingNewsContent data={data} />
          </div>
        </div >
      }
    </>
  )
}
OlympicsTrendingNews.propTypes = {
  data: PropTypes.any
}

export default OlympicsTrendingNews
